export default __webpack_public_path__ + "static/media/card-insta-suvinil2.61c178d7.jpg";